import React, { useState } from "react";
import { Table } from "../DataTable";
import CreateTask from "../../smart/buttonPopups/CreateTask";
import DeleteTask from "../../smart/buttonPopups/DeleteTask";
import SplitTask from "../../smart/buttonPopups/SplitTask";
import AssignTaskTranslator from "../../smart/buttonPopups/AssignTaskTranslator";
import AssignTaskEditor from "../../smart/buttonPopups/AssignTaskEditor";
import SetTaskDue from "../../smart/buttonPopups/SetTaskDue";
import AnalyzeTask from "../../smart/buttonPopups/AnalyzeTask";
import PreTranslateTask from "../../smart/buttonPopups/PreTranslateTask";
import SetTaskStatus from "../../smart/buttonPopups/SetTaskStatus";
import DeleteTranslations from "../../smart/buttonPopups/DeleteTranslations";

const ProjectTasks = props => {

    const [checkValues, setCheckValues] = useState([]);

    const renderRow = (row, renderData) =>
        <React.Fragment>
            {renderData(row.ID, { key: "id" })}
            {renderData(row.name, { key: "name", here: "/task/translate/" + row.ID })}
            {renderData(row.sourceLang, { key: "source" })}
            {renderData(row.targetLang, { key: "target" })}
            {renderData(row.translator, { key: "translator" })}
            {renderData(row.tDue, { key: "tdue" })}
            {renderData(row.tCompleted, { key: "tcompleted" })}
            {renderData(row.editor, { key: "editor" })}
            {renderData(row.eDue, { key: "edue" })}
            {renderData(row.eCompleted, { key: "ecompleted" })}
            {renderData(row.status, { key: "status" })}
        </React.Fragment>

    const titleContent = <React.Fragment>
        <CreateTask projectID={props.projectID} />
        <AssignTaskTranslator className={checkValues.length <= 0 ? "button--disabled" : ""} selectedTasks={checkValues} projectID={props.projectID} />
        <AssignTaskEditor className={checkValues.length <= 0 ? "button--disabled" : ""} selectedTasks={checkValues} projectID={props.projectID} />
        <DeleteTask className={checkValues.length <= 0 ? "button--disabled" : ""} selectedTasks={checkValues} projectID={props.projectID} />
        <SplitTask className={checkValues.length != 1 ? "button--disabled" : ""} selectedTasks={checkValues} projectID={props.projectID} />
        <AnalyzeTask projectID={props.projectID} taskID={checkValues} className={checkValues.length < 1 ? "button--disabled" : ""} />
        <SetTaskDue className={checkValues.length <= 0 ? "button--disabled" : ""} selectedTasks={checkValues} taskID={props.taskID} />
        <PreTranslateTask taskIDs={checkValues} className={checkValues.length < 1 ? "button--disabled" : ""} />
        <SetTaskStatus className={checkValues.length <= 0 ? "button--disabled" : ""} selectedTasks={checkValues} taskID={props.taskID} />
        <DeleteTranslations className={checkValues.length <= 0 ? "button--disabled" : ""} selectedTasks={checkValues} projectID={props.projectID} />
    </React.Fragment>

    return (
        <React.Fragment>
            <Table checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} cols={[
                { name: "id", sortCol: "ID" },
                { name: "name", sortCol: "name" },
                { name: "src", sortCol: "sourceLang" },
                { name: "trg", sortCol: "targetLang" },
                { name: "t", sortCol: "translator" },
                { name: "t due", sortCol: "tDue" },
                { name: "t %", sortCol: "tCompleted" },
                { name: "e", sortCol: "editor" },
                { name: "e due", sortCol: "eDue" },
                { name: "e %", sortCol:"eDue" },
                { name: "status", sortCol:"status" }
            ]}
                rows={props.rows} renderRow={renderRow}

                title="Tasks"

                titleContent={titleContent}
            />
        </React.Fragment>
    )
}

export default ProjectTasks;